import { Text, Button, Popover, Grid, GridCol } from '@mantine/core';
import { TexturesSelect } from './TexturesSelect';
import { WorkflowConfig } from '@/app/workflows/actions/interfaces';

type TexturesModalProps = {
  onChanged: (value: Partial<NonNullable<WorkflowConfig['limits']>['textures']>) => void;
  values: NonNullable<WorkflowConfig['limits']>['textures'];
};

export function CustomisedTexturesSelection({ onChanged, values }: TexturesModalProps) {
  return (
    <Popover width={400} position='bottom' withArrow shadow='md'>
      <Popover.Target>
        <Button variant='default' onClick={() => open()}>
          Customize
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Grid>
          <GridCol span={4}>
            <Text>Base Color</Text>
          </GridCol>
          <GridCol span={8}>
            <TexturesSelect
              onChange={(value) => (value ? onChanged({ baseColor: parseInt(value) }) : null)}
              value={values?.baseColor.toString()}
            />
          </GridCol>
          <GridCol span={4}>
            <Text>Emissive</Text>
          </GridCol>
          <GridCol span={8}>
            <TexturesSelect
              onChange={(value) => (value ? onChanged({ emissive: parseInt(value) }) : null)}
              value={values?.emissive.toString()}
            />
          </GridCol>
          <GridCol span={4}>
            <Text>Normal</Text>
          </GridCol>
          <GridCol span={8}>
            <TexturesSelect
              onChange={(value) => (value ? onChanged({ normal: parseInt(value) }) : null)}
              value={values?.normal.toString()}
            />
          </GridCol>
          <GridCol span={4}>
            <Text>Orm</Text>
          </GridCol>
          <GridCol span={8}>
            <TexturesSelect
              onChange={(value) => (value ? onChanged({ orm: parseInt(value) }) : null)}
              value={values?.orm.toString()}
            />
          </GridCol>
        </Grid>
      </Popover.Dropdown>
    </Popover>
  );
}
